<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>account_balance</mat-icon></div>
    <div class="ba-header-text">
      <h2 class="cf-dlg-title">{{ title }}</h2>
      <p class="cf-dlg-subtitle">{{ subtitle }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="cancel()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="!ready" message="Cargando cuenta bancaria…"></app-loading-state>
  <app-loading-state *ngIf="ready && saving" [message]="isEdit ? 'Guardando cuenta bancaria…' : 'Creando cuenta bancaria…'"></app-loading-state>

  <ng-container *ngIf="ready && !saving && loadError">
    <div class="cf-dlg-body">
      <div class="cf-dlg-mismatch">
        <mat-icon>error</mat-icon>
        <span>{{ loadError }}</span>
      </div>
    </div>
    <div class="cf-dlg-footer">
      <button type="button" mat-stroked-button class="cf-dlg-btn-secondary" (click)="cancel()">Cerrar</button>
      <button type="button" mat-flat-button class="cf-dlg-btn-primary" (click)="load()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="ready && !saving && !loadError">
    <form class="ba-form" [formGroup]="form" (ngSubmit)="save()" novalidate>
      <div class="cf-dlg-body">
        <div class="cf-dlg-mismatch" *ngIf="saveError">
          <mat-icon>error</mat-icon>
          <span>{{ saveError }}</span>
        </div>

        <span class="cf-dlg-section__label">Entidad</span>

        <div class="cf-field--required" [class.cf-field--invalid]="isInvalid('swift')">
          <app-autocomplete [control]="form.controls.swift" [config]="swiftConfig"></app-autocomplete>
        </div>

        <div class="cf-field--required" [class.cf-field--invalid]="isInvalid('bank')">
          <app-field [control]="form.controls.bank" [config]="bankConfig"></app-field>
        </div>

        <span class="cf-dlg-section__label">Cuenta</span>

        <div class="cf-field--required" [class.cf-field--invalid]="isInvalid('iban')">
          <app-field [control]="form.controls.iban" [config]="ibanConfig"></app-field>
        </div>

        <div class="ba-uid" *ngIf="entity?.uid">
          <button type="button" class="ba-link" (click)="showUid = !showUid">
            <mat-icon>{{ showUid ? 'visibility_off' : 'visibility' }}</mat-icon>
            {{ showUid ? 'Ocultar UID' : 'Ver UID' }}
          </button>
          <span class="ba-uid__value" *ngIf="showUid">{{ entity?.uid }}</span>
        </div>
      </div>

      <div class="cf-dlg-footer">
        <button type="button" mat-stroked-button class="cf-dlg-btn-secondary" (click)="cancel()">Cancelar</button>
        <button type="submit" mat-flat-button class="cf-dlg-btn-primary" [disabled]="saving">
          <mat-icon>save</mat-icon> {{ isEdit ? 'Guardar cambios' : 'Crear cuenta' }}
        </button>
      </div>
    </form>
  </ng-container>
</div>
